<template>
    <LovCountryLayout :country="country">
        <DCard
            padding
        >
            <DRow
                class="mb-3"
                align-horizontal="start"
                align-vertical="end"
            >
                <DCol
                    sm="3"
                    class="pt-1"
                >
                    <DInput
                        id="search"
                        v-model="filterParams.search"
                        :label="__('messages.search')"
                        class="mb-0"
                    />
                </DCol>
                <DCol
                    sm="3"
                    class="d-flex gap-2"
                >
                    <DButton
                        id="filter-apply"
                        :label="__('messages.actions.filter')"
                        @click="filterStates"
                    />
                    <DButton
                        id="filter-reset"
                        icon="filter-off"
                        :label="__('messages.actions.reset_filter')"
                        @click="resetFilters"
                    />
                </DCol>
            </DRow>
            <DTable
                :items="states"
                class="table-responsive"
                :fields="[
                    {key: 'state_code', label: __('settings.countries.states.table.headers.state_code')},
                    {key: 'country_code', label: __('settings.countries.states.table.headers.country_code')},
                    {key: 'name_de', label: __('settings.countries.states.table.headers.name_de')},
                    {key: 'name_en', label: __('settings.countries.states.table.headers.name_en')},
                    {key: 'name_da', label: __('settings.countries.states.table.headers.name_da')},
                    {key: 'name_nl', label: __('settings.countries.states.table.headers.name_nl')},
                    {key: 'name_fi', label: __('settings.countries.states.table.headers.name_fi')},
                    {key: 'name_fr', label: __('settings.countries.states.table.headers.name_fr')},
                    {key: 'name_it', label: __('settings.countries.states.table.headers.name_it')},
                    {key: 'name_no', label: __('settings.countries.states.table.headers.name_no')},
                    {key: 'name_pr', label: __('settings.countries.states.table.headers.name_pr')},
                    {key: 'name_es', label: __('settings.countries.states.table.headers.name_es')},
                    {key: 'name_sv', label: __('settings.countries.states.table.headers.name_sv')},
                    {key: 'name_sk', label: __('settings.countries.states.table.headers.name_sk')},
                    {key: 'name_cz', label: __('settings.countries.states.table.headers.name_cz')},
                    {key: 'name_rs', label: __('settings.countries.states.table.headers.name_rs')},
                    {key: 'actions', label: '', sorter: false}
                ]"
                hover
                sorter
            >
                <template #actions="{item}">
                    <td>
                        <div style="display: flex; grid-gap: 10px;">
                            <DButton
                                :id="`edit_${item.id}`"
                                icon="pencil"
                                mini
                                @click="$inertia.get(editStateObject(item.id))"
                            />
                            <DButton
                                :id="`btn-delete-${item.id}`"
                                icon="trash-can-outline"
                                color="danger"
                                mini
                                :disabled="isInLoadingState || item.used_anywhere === 1"
                                @click="openDeleteModal(item.id)"
                            />
                        </div>
                    </td>
                </template>
            </DTable>

            <DFabs>
                <DFab
                    id="btn-add"
                    icon="plus"
                    :label="__('settings.countries.states.add_state_button')"
                    @click="addState"
                />
            </DFabs>

            <DModal
                v-model:show="showDeleteModal"
                :title="__('settings.countries.states.delete_confirm_modal.title')"
                :message="__('settings.countries.states.delete_confirm_modal.message')"
                is-confirm
                is-error
                @close="closeDeleteModal"
                @confirm="deleteStateObject"
            />
        </DCard>
    </LovCountryLayout>
</template>

<script>
import App from '~@/App.vue'
import { ref } from 'vue'
import { router } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import LovCountryLayout from '../../Lov/LovCountryLayout.vue'

export default {
    layout: [App]
}
</script>

<script setup>

const props = defineProps({
    country: {
        type: Object,
        default: () => ({})
    },
    states: {
        type: Array,
        default: () => []
    },
    filters: {
        type: Object,
        default: () => ({})
    }
})

const filterParams = {
    search: props.filters.search,
}

const showDeleteModal = ref(false)
const selectedState = ref(null)

function openDeleteModal (stateId) {
    showDeleteModal.value = true
    selectedState.value = stateId
}

function closeDeleteModal () {
    showDeleteModal.value = false
    selectedState.value = null
}

const editStateObject = (stateId) => route('settings.countries.states.edit', { country: props.country.country_code, state: stateId })

const deleteStateObject = () => router.delete(route('settings.countries.states.destroy', { country: props.country.country_code, state: selectedState.value }))

const addState = () => router.get(route('settings.countries.states.create', { country: props.country.country_code }))

const filterStates = () => router.get(route('settings.countries.states.index', {
    country: props.country.country_code,
    save_filters: true,
}), filterParams)

const resetFilters = () => router.get(route('settings.countries.states.index', {
    country: props.country.country_code,
    save_filters: true,
    default_filters: true
}))

</script>
